<template>
  <div class="comment">
    <div class="userInfo" v-if="commentInfo">
      <div class="userNameEmail">
        <span class="name"> {{ commentInfo.createdBy.firstName + ' ' + commentInfo.createdBy.lastName }} </span>
        <span class="email"> {{ commentInfo.createdBy.email }}</span>
      </div>

      <span class="commentDate">
        <span class="material-icons"> av_timer </span>
        {{ getReadableCreatedAtDate(commentInfo.createdAt) }}
      </span>
    </div>
    <div class="comment-message">
      <p>{{ commentInfo.message }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    commentInfo: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('tasks', ['users'])
  },
  methods: {
    getReadableCreatedAtDate(dateString) {
      const date = new Date(dateString);
      const monthName = [
        'month.january',
        'month.february',
        'month.march',
        'month.april',
        'month.may',
        'month.june',
        'month.july',
        'month.august',
        'month.september',
        'month.octobre',
        'month.november',
        'month.december'
      ];

      const currentMonthName = this.$t(monthName[date.getMonth()]);
      return `${('0' + date.getDate()).slice(-2)} ${currentMonthName} ${date.getFullYear()}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.comment {
  margin-bottom: 32px;
}

.userNameEmail {
  position: relative;
  display: flex;
  flex-direction: column;
}

.userInfo {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

@media only screen and (max-width: 1000px) {
  .tags {
    margin: 0px;
  }

  .userNameEmail {
    display: flex;
    flex-direction: column;
  }

  .userInfo {
    .commentDate {
      &.overdue {
        color: #e32;
      }
    }
  }
}

.picture {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  display: inline-block;
  margin-right: 16px;

  img {
    width: 32px;
    border-radius: 4px;
    max-height: 32px;
  }
}

.name {
  font-weight: bold;
}

.name,
.email {
  font-size: var(--text-size-small);
}

.commentDate {
  font-size: var(--text-size-small);
  color: #818e96;

  &.overdue {
    color: #e32;
  }

  .material-icons {
    vertical-align: bottom;
  }
}
</style>
